import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4db89158")

_pushScopeId("data-v-4db89158")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "code" }
const _hoisted_3 = { class: "resend-code" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Não recebeu um código?", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Confirmar")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_basic_header = _resolveComponent("basic-header")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_basic_header, { title: "Validar Telefone" }),
          _createVNode("div", _hoisted_1, [
            _createVNode("section", null, " Para validar seu telefone, copie aqui o código que enviamos por SMS para o número " + _toDisplayString(_ctx.formatPhone(_ctx.phone)), 1),
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ion_input, {
                ref: "input1",
                modelValue: _ctx.code1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.code1 = $event)),
                type: "tel",
                color: "medium",
                maxlength: "1",
                autocomplete: "off",
                onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextInput($event, 1)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_input, {
                ref: "input2",
                modelValue: _ctx.code2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.code2 = $event)),
                type: "tel",
                color: "medium",
                maxlength: "1",
                autocomplete: "off",
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nextInput($event, 2)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_input, {
                ref: "input3",
                modelValue: _ctx.code3,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.code3 = $event)),
                type: "tel",
                color: "medium",
                maxlength: "1",
                autocomplete: "off",
                onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nextInput($event, 3)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_input, {
                ref: "input4",
                modelValue: _ctx.code4,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.code4 = $event)),
                type: "tel",
                color: "medium",
                maxlength: "1",
                autocomplete: "off",
                onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.nextInput($event, 4)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_input, {
                ref: "input5",
                modelValue: _ctx.code5,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.code5 = $event)),
                type: "tel",
                color: "medium",
                maxlength: "1",
                autocomplete: "off",
                onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.nextInput($event, 5)))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_ion_button, {
                shape: "outline",
                disabled: _ctx.counter > 0,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendCode()))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.buttonName), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_button, {
                shape: "round",
                expand: "full",
                color: "primary",
                onClick: _ctx.validateCodePhone
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})